import { Storage } from "@faire/web--source/common/Storage";
export var nextValue = function(arr, key) {
    var _Storage_local_getItem;
    var numTimesSeenBanners = parseInt((_Storage_local_getItem = Storage.local.getItem(key)) !== null && _Storage_local_getItem !== void 0 ? _Storage_local_getItem : "0");
    Storage.local.setItem(key, (numTimesSeenBanners + 1).toString());
    var bannerToShowIndex = numTimesSeenBanners % arr.length;
    return arr[bannerToShowIndex];
};
